export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL
export const API_URL = process.env.REACT_APP_API_URL
export const HOME_URL = process.env.REACT_APP_HOME_URL
export const MEMBER_URL = process.env.REACT_APP_MEMBER_URL
// export const NEW_MEMBER_URL = process.env.REACT_APP_NEW_MEMBER_URL
export const NEW_MEMBER_URL = 'https://lin.ee/d6bhYB9'
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY
export const LINE_LIFF_ID_MEMBER = process.env.REACT_APP_LINE_LIFF_ID_MEMBER
